import axios from 'axios';
import { API_URL } from '../config';

export const getRepairOrders = ({ repairOrders }) => repairOrders;

const reducerName = 'repairOrders';
const createActionName = (name) => `app/${reducerName}/${name}`;
const LOAD_REPAIR_ORDERS = createActionName('LOAD_REPAIR_ORDERS');
const ADD_REPAIR_ORDER = createActionName('ADD_REPAIR_ORDER');
const EDIT_REPAIR_ORDER = createActionName('EDIT_REPAIR_ORDER');
const DELETE_REPAIR_ORDER = createActionName('DELETE_REPAIR_ORDER');

export const loadRepairOrders = (payload) => ({
  payload,
  type: LOAD_REPAIR_ORDERS,
});
export const addRepairOrder = (payload) => ({
  payload,
  type: ADD_REPAIR_ORDER,
});
export const editRepairOrder = (payload) => ({
  payload,
  type: EDIT_REPAIR_ORDER,
});
export const deleteRepairOrder = (payload) => ({
  payload,
  type: DELETE_REPAIR_ORDER,
});

export const loadRepairOrdersRequest = () => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/repair-orders`, {
        withCredentials: true,
      });

      dispatch(loadRepairOrders(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const addRepairOrderRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/repair-orders`, data, {
        withCredentials: true,
      });
      dispatch(addRepairOrder(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const addBinToRepairOrderRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(
        `${API_URL}/repair-orders/add-bin/${data.id}`,
        data,
        {
          withCredentials: true,
        },
      );
      dispatch(editRepairOrder(res.data));
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createTransferRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/segregation/transfer`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createSegregationResultRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/segregation/result`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const changeStatusOfFinalizationRequest = (data) => {
  return async (dispatch) => {
    try {
      console.log(data);
      let res = await axios.patch(
        `${API_URL}/segregation/finalization/${data.id}`,
        data,
        {
          withCredentials: true,
        },
      );
      console.log(res);
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createSegregationFinalizeRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/segregation/finalize`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const loadRepairOrderByIdRequest = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/repair-orders/${id}`, {
        withCredentials: true,
      });

      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const closeRepairOrderRequest = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/repair-orders/close/${id}`, {
        withCredentials: true,
      });
      dispatch(deleteRepairOrder(id));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

const repairOrderReducer = (statePart = [], action) => {
  switch (action.type) {
    case LOAD_REPAIR_ORDERS:
      return action.payload;
    case ADD_REPAIR_ORDER:
      return [...statePart, action.payload];
    case EDIT_REPAIR_ORDER:
      return statePart.map((order) =>
        order.id === action.payload.id ? action.payload : order,
      );
    case DELETE_REPAIR_ORDER:
      return statePart.filter((order) => order.id !== action.payload);
    default:
      return statePart;
  }
};
export default repairOrderReducer;
